import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Transition as _Transition } from "vue"

const _hoisted_1 = { key: 0 }

import useMaterialAndColor from '@/shared/product/customizer/ui/overlays/material-and-color/useMaterialAndColor';
import SearchResultMaterial from '@/shared/product/customizer/ui/overlays/material-and-color/SearchResultMaterial.vue';
import { computed, watch } from 'vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import SearchResultSkeleton from '@/shared/product/customizer/ui/overlays/material-and-color/SearchResultSkeleton.vue';
import useNetPrices from '@/b2b/product/useNetPrices';
import authStore from '@/shared/auth/auth.store';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchResult',
  setup(__props) {


const labels = useBlockLabels();
const { filteredMaterials, materialFacetOptionsSelectedIndex, isPending } = useMaterialAndColor();
const { fetchNetPrices } = useNetPrices();

const shouldShowNoResults = computed(() => filteredMaterials.value.length === 0 && !isPending.value);

const fetchNetPriceForItems = () => {
    if (isSignedInAsPartner.value) {
        fetchNetPrices(filteredMaterials.value.map((material) => material.variantWithPrices[0].sku));
    }
};

const isSignedInAsPartner = computed<boolean>(() => {
    return authStore.isSignedInAsPartner;
});

watch(filteredMaterials, fetchNetPriceForItems, { immediate: true });

return (_ctx: any,_cache: any) => {
  return (_unref(isPending))
    ? (_openBlock(), _createBlock(SearchResultSkeleton, { key: 0 }))
    : (_openBlock(), _createBlock(_Transition, {
        key: 1,
        name: "o-anim-fade-200",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock("div", { key: _unref(materialFacetOptionsSelectedIndex) }, [
            _createVNode(_TransitionGroup, { name: "o-anim-fade-200" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredMaterials), (material, idx) => {
                  return (_openBlock(), _createBlock(SearchResultMaterial, {
                    key: material.name+idx,
                    material: material
                  }, null, 8, ["material"]))
                }), 128))
              ]),
              _: 1
            }),
            (_unref(shouldShowNoResults))
              ? (_openBlock(), _createElementBlock("h4", _hoisted_1, _toDisplayString(_unref(labels).overlayMaterialNoResultsForSelectedFacets), 1))
              : _createCommentVNode("", true)
          ]))
        ]),
        _: 1
      }))
}
}

})